import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Renders all page-level SEO tags from the `seo` object returned by the
 * backend (title, metaDescription, canonical, robots, og*, twitter*,
 * schemas[]). Centralizing this means every dynamic Service/Blog page gets
 * a consistent, complete set of tags without re-implementing them per page.
 */
const SeoHead = ({ seo, siteName = 'BusinessMate Workflow' }) => {
  if (!seo) return null;

  const {
    title,
    metaDescription,
    canonical,
    robots = 'index,follow',
    ogTitle,
    ogDescription,
    ogImage,
    twitterTitle,
    twitterDescription,
    twitterImage,
    schemas = []
  } = seo;

  return (
    <Helmet>
      <title>{title}</title>
      {metaDescription && <meta name="description" content={metaDescription} />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta name="robots" content={robots} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteName} />
      {ogTitle && <meta property="og:title" content={ogTitle} />}
      {ogDescription && <meta property="og:description" content={ogDescription} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      {canonical && <meta property="og:url" content={canonical} />}

      <meta name="twitter:card" content="summary_large_image" />
      {twitterTitle && <meta name="twitter:title" content={twitterTitle} />}
      {twitterDescription && <meta name="twitter:description" content={twitterDescription} />}
      {twitterImage && <meta name="twitter:image" content={twitterImage} />}

      {schemas.filter(Boolean).map((schema, idx) => (
        <script key={idx} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default SeoHead;
